/**
 * File validation constants
 */
export const FileValidation = {
    MAX_FILE_SIZE: 100 * 1024 * 1024, // 100MB in bytes
    ACCEPTED_TYPES: ['application/pdf'],
    ACCEPTED_EXTENSIONS: ['.pdf'],
};

/**
 * File size units
 */
export const FileSizeUnits = ['B', 'KB', 'MB', 'GB'];

/**
 * Validation messages
 */
export const ValidationMessages = {
    INVALID_FILE_TYPE: 'Apenas arquivos PDF são permitidos.',
    FILE_TOO_LARGE: 'O arquivo excede o limite de 100MB.',
    FILE_READ_ERROR: 'Falha ao ler o arquivo. Tente novamente.',
    MATERIAL_REQUIRED: 'Insira um material para continuar',
    TITLE_REQUIRED: 'Insira o título do material para continuar',
};
